import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrustiiService} from 'src/app/services/trustii.service';

@Component({
  selector: 'app-invite-user-dialog',
  templateUrl: './invite-user.dialog.html',
  styleUrls: ['./invite-user.dialog.scss']
})
export class InviteUserDialogComponent {
  public firstname: string;
  public lastname: string;
  public email: string;
  inProgress = false;
  validForm = false;
  isValidEmail = null;
  isValidFirstname = null;
  isValidLastname = null;
  accountExistError = false;
  emailRegexp = new RegExp(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string },
    private dialogRef: MatDialogRef<InviteUserDialogComponent>,
    private trustiiService: TrustiiService
  ) {
  }

  invite() {
    this.inProgress = true;
    const data = {
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
    };
    this.trustiiService.inviteUser(data).subscribe(
      (res) => {
        this.dialogRef.close({data: 'confirmation'});
      },
      (err) => {
        const jerr = JSON.parse(JSON.stringify(err.error.error));
        if (err && err.error && jerr.status === 400 && jerr.code === 'account_already_exist') {
          this.accountExistError = true;
          this.isValidEmail = false;
        }
        this.inProgress = false;
      }
    );
  }

  onEmailKey(e) {
    this.email = e.target.value;
    this.accountExistError = false;

    if (this.email.length === 0) {
      this.isValidEmail = null;
    } else if (this.emailRegexp.test(this.email)) {
      this.isValidEmail = true;
    } else {
      this.isValidEmail = false;
    }

    this.updateFormValidity();
  }

  onFirstName(e) {
    this.firstname = e.target.value;
    this.isValidFirstname = false;
    if (this.firstname.length >= 2 && this.firstname.length <= 100) {
      this.isValidFirstname = true;
    }
    this.updateFormValidity();
  }

  onLastName(e) {
    this.lastname = e.target.value;
    this.isValidLastname = false;
    if (this.lastname.length >= 2 && this.lastname.length <= 100) {
      this.isValidLastname = true;
    }
    this.updateFormValidity();
  }

  updateFormValidity() {
    if (this.isValidEmail && this.isValidLastname && this.isValidFirstname) {
      this.validForm = true;
    } else {
      this.validForm = false;
    }
  }
}
